import { render, staticRenderFns } from "./MatchPayProcessingStep.vue?vue&type=template&id=6d3b86a1"
import script from "./MatchPayProcessingStep.vue?vue&type=script&lang=js"
export * from "./MatchPayProcessingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports